import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { ErrorToast } from "../../shared/toasters/toasters";
import logoLight from "../../assets/images/Frame 27.png";
import logoDark from "../../assets/images/Frame 26.png";
import { useTheme } from "../../context/ThemeContext";

const Login: React.FC = () => {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const auth = useContext(AuthContext);
  const navigate = useNavigate();
  const { theme } = useTheme(); // 'theme' could be 'light' or 'dark'

  if (!auth) {
    throw new Error("AuthContext must be used within an AuthProvider");
  }

  const { login } = auth;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await login(credentials);
      navigate("/dashboard");
    } catch (error: any) {
      console.error(error);
    }
  };

  return (
    <div className="auth-main v1">
      <div className="auth-wrapper">
        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="card my-5">
            <div className="card-body">
              <div className="text-center">
                <div className="w-50 m-auto">
                  {theme === "dark" ? (
                    <img
                      src={logoLight}
                      alt="logo"
                      className="logo-lg w-100 landing-logo img-fluid"
                    />
                  ) : (
                    <img
                      src={logoDark}
                      alt="logo"
                      className="logo-lg w-100 landing-logo img-fluid"
                    />
                  )}
                </div>

                <h4 className="f-w-500 mb-1">Login with your email</h4>
                <p className="mb-3">
                  Don't have an Account?{" "}
                  <a
                    href="../pages/register-v1.html"
                    className="link-primary ms-1"
                  >
                    Create Account
                  </a>
                </p>
              </div>
              <div className="mb-3">
                <input
                  type="email"
                  className="form-control"
                  id="floatingInput"
                  placeholder="Email Address"
                  value={credentials.email}
                  onChange={(e) =>
                    setCredentials({ ...credentials, email: e.target.value })
                  }
                />
              </div>
              <div className="mb-3">
                <input
                  type="password"
                  className="form-control"
                  id="floatingInput1"
                  placeholder="Password"
                  value={credentials.password}
                  onChange={(e) =>
                    setCredentials({ ...credentials, password: e.target.value })
                  }
                />
              </div>
              <div className="d-flex mt-1 justify-content-between align-items-center">
                <div className="form-check">
                  <input
                    className="form-check-input input-primary"
                    type="checkbox"
                    id="customCheckc1"
                  />{" "}
                  <label
                    className="form-check-label text-muted"
                    htmlFor="customCheckc1"
                  >
                    Remember me?
                  </label>
                </div>
                <a href="../pages/forgot-password-v1.html">
                  <h6 className="f-w-400 mb-0">Forgot Password?</h6>
                </a>
              </div>
              <div className="d-grid mt-4">
                <button type="submit" className="btn btn-primary">
                  Login
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
